import { __extends } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { playButtonSound } from '@wg/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import DivTooltip from '../DivTooltip/DivTooltip.js';
import Tooltip from '../Tooltip/Tooltip.js';
import TooltipBody from '../Tooltip/TooltipBody.js';
import styles from './Button.module.scss.js';

var buttonTypes = {
    orange: styles.isOrange,
    secondary: styles.isSecondary,
};
var Button = (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            labelWidth: 0,
            containerWidth: 0,
        };
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    Button.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            var cWidth = _this.container ? _this.container.offsetWidth : 0;
            var lWidth = _this.label ? _this.label.offsetWidth : 0;
            _this.setState({
                labelWidth: lWidth,
                containerWidth: cWidth,
            });
        }, 0);
    };
    Button.prototype.onClick = function (event) {
        event.stopPropagation();
        if (this.props.isDisabled) {
            return;
        }
        playButtonSound();
        event.currentTarget.blur();
        if (this.props.onClick) {
            this.props.onClick(event);
        }
    };
    Object.defineProperty(Button.prototype, "useEllipsis", {
        get: function () {
            var ellipsisWidth = 10;
            var labelPaddings = 36;
            return (this.props.isEllipsis && this.state.labelWidth > this.state.containerWidth + ellipsisWidth - labelPaddings);
        },
        enumerable: false,
        configurable: true
    });
    Button.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var _d, _e, _f, _g;
        var useEllipsis = this.useEllipsis;
        var classNameContainer = classNames(styles.container, (_a = {},
            _a[styles.isJustified] = this.props.isJustified,
            _a));
        var classNameButton = classNames(styles.button, (_b = {},
            _b[buttonTypes[this.props.type || 'secondary']] = !!this.props.type,
            _b[styles.isIcon] = !!this.props.isIcon,
            _b[styles.isLarger] = !!this.props.isLarger,
            _b[styles.isDisabled] = !!this.props.isDisabled,
            _b[styles.isHighlighted] = !!this.props.isHighlighted,
            _b[styles.isFlat] = !!this.props.isFlat,
            _b[styles.isSmaller] = !!this.props.isSmaller,
            _b));
        var classNameInner = useEllipsis
            ? classNames(styles.inner, (_c = {},
                _c[styles.isEllipsis] = this.props.isEllipsis,
                _c))
            : styles.inner;
        var tooltipContent = this.props.tooltipContent;
        if (!tooltipContent && useEllipsis) {
            tooltipContent = jsx(TooltipBody, { children: this.props.children });
        }
        var tooltip = tooltipContent ? jsx(Tooltip, { children: tooltipContent }) : null;
        var btn = (jsx("button", { className: classNameButton, onClick: this.onClick, onMouseOver: (_d = this.props) === null || _d === void 0 ? void 0 : _d.onMouseOver, onMouseOut: (_e = this.props) === null || _e === void 0 ? void 0 : _e.onMouseOut, onMouseEnter: (_f = this.props) === null || _f === void 0 ? void 0 : _f.onMouseEnter, onMouseLeave: (_g = this.props) === null || _g === void 0 ? void 0 : _g.onMouseLeave, children: jsx("div", { className: classNameInner, children: jsx("span", { ref: function (c) {
                        _this.label = c;
                    }, children: this.props.children }) }) }));
        if (tooltip) {
            return (jsx(DivTooltip, { className: classNames(classNameContainer, this.props.className), tooltipBody: tooltip, children: btn }));
        }
        else {
            return (jsx("div", { className: classNames(classNameContainer, this.props.className), ref: function (c) {
                    _this.container = c;
                }, children: btn }));
        }
    };
    return Button;
}(React.PureComponent));

export { Button as default };
//# sourceMappingURL=Button.js.map
